import { history } from "instantsearch.js/es/lib/routers"
import {
  resultsFilters,
  MAX_DURATION,
  MAX_RELEASE_YEAR,
  MIN_RELEASE_YEAR,
  sortOptions,
  mapSortToReplica
} from "../../pages/browse/FilterTransforms"

const vocalItems = ["is_instrumental", "is_vocals", "is_female_vocals", "is_male_vocals"]
const replicaToKey = (baseIndex, replica) => {
  if (!replica || replica === baseIndex) return "default"
  const match = sortOptions.find(opt => mapSortToReplica(baseIndex, opt.value) === replica)
  return match ? match.value : "default"
}

// THIS WHOLE FILE MIGHT ALSO BE UNNECESSARY NOW
export const algoliaRouting = {
  router: history(),
  stateMapping: {
    stateToRoute(uiState) {
      const base = getIndexName()
      const indexUiState = uiState[base]
      const sortKey = indexUiState?.sortBy
        ? replicaToKey(base, indexUiState.sortBy)
        : "default"
      return {
        query: indexUiState?.query,
        vocals: toggledVocalItems(indexUiState?.toggle),
        moods: indexUiState?.refinementList?.mood_list?.join("~"),
        energies: indexUiState?.refinementList?.energy?.join("~"),
        arcs: indexUiState?.refinementList?.arc?.join("~"),
        length: selectedDuration(indexUiState?.range?.duration),
        release_year: selectedReleaseYear(indexUiState?.range?.release_year),
        instruments: indexUiState?.refinementList?.instrument_list?.join("~"),
        genres: indexUiState?.refinementList?.genre_list?.join("~"),
        options: toggledOptionItems(indexUiState?.toggle),
        filter: selectedResultsFilter(indexUiState?.configure?.restrictSearchableAttributes),
        page: indexUiState?.page,
        flags: indexUiState?.refinementList?.internal_flags?.join("~"),
        sort: (sortKey && sortKey !== "default") ? sortKey : undefined,
      }
    },
    routeToState(routeState) {
      return {
        [getIndexName()]: {
          query: routeState.query,
          refinementList: {
            instrument_list: routeState.instruments?.split("~"),
            genre_list: routeState.genres?.split("~"),
            mood_list: routeState.moods?.split("~"),
            arc: routeState.arcs?.split("~"),
            energy: routeState.energies?.split("~"),
            internal_flags: routeState.flags?.split("~"),
          },
          range: {
            
            duration: routeState.length?.replace("-", ":"),
            release_year: routeState.release_year?.replace("-", ":"),
          },
          toggle: combineToggledItems(routeState),
          page: routeState.page ? parseInt(routeState.page, 10) : undefined,
          sortBy: routeState.sort ? mapSortToReplica(getIndexName(), routeState.sort) : undefined,
          configure: {
            // Pre-hydrate all Configure params to prevent a post-mount change that resets page
            hitsPerPage: 25,
            getRankingInfo: true,
            distinct: 10,
            ruleContexts: [getUserRole()].filter(Boolean),
            ...(routeState.filter
              ? {
                  restrictSearchableAttributes:
                    resultsFilters.find((item) => item.name === routeState.filter)
                      ?.restrictedAttributes,
                }
              : {}),
          },
        },
      }
    },
  },
}

const getIndexName = () => {
  // This avoids losing pagination when redirecting back after login
  if (typeof window !== "undefined" && window.__AIS_INDEX_NAME__) {
    return window.__AIS_INDEX_NAME__
  }
  const el = document.getElementById("mm-browse-beta-container")
  const indexName = el && el.getAttribute("data-index-name")
  return indexName
}

const getUserRole = () => {
  const el = document.getElementById("mm-browse-beta-container")
  return el && el.getAttribute("data-user-role")
}

const selectedDuration = (duration) => {
  if (!duration) return
  const range = duration.split(":")
  const min = range[0] === "0" ? "" : range[0]
  const max = range[1] === MAX_DURATION.toString() ? "" : range[1]
  if (!min && !max) return
  return `${min}-${max}`
}

const selectedReleaseYear = (releaseYear) => {
  if (!releaseYear) return
  const range = releaseYear.split(":")
  const min = ["0", "1920"].includes(range[0]) ? "" : range[0]
  const max = range[1] === MAX_RELEASE_YEAR.toString() ? "" : range[1]
  if (!min && !max) return
  return `${min}-${max}`
}

const selectedResultsFilter = (restrictedList) => {
  if (!restrictedList || !restrictedList.length) return

  const matchingResultsFilter = resultsFilters.find(
    (item) => item.restrictedAttributes === restrictedList
  )
  return matchingResultsFilter ? matchingResultsFilter.name : undefined
}

const toggledVocalItems = (toggledList) => {
  if (!toggledList) return

  const toggledItems = Object.keys(toggledList)
    .filter((item) => vocalItems.includes(item))
    .map((item) => item.replace("is_", ""))
    .join("~")
  return toggledItems.length ? toggledItems : undefined
}

const toggledOptionItems = (toggledList) => {
  if (!toggledList) return

  const toggledItems = Object.keys(toggledList)
    .filter((item) => !vocalItems.includes(item))
    .map((item) => item.replace("is_", ""))
    .join("~")
  return toggledItems.length ? toggledItems : undefined
}

const combineToggledItems = (routeState) => {
  if (!routeState.vocals && !routeState.options) return

  const hasToggledItems = [routeState.vocals, routeState.options].filter(
    (item) => item && item.length
  )
  const toggledItems = [...hasToggledItems].join("~")
  return toggledItems.split("~").reduce((acc, cur) => ({ ...acc, ["is_" + cur]: true }), {})
}
